import {ClaimStatus} from '../product'

export const PurchaseConfirmationErrorCode = {
    PURCHASE_DECISION_VALIDATION_FAILED: 'PURCHASE_DECISION_VALIDATION_FAILED',
    PURCHASE_DECISION_VALIDATION_FAILED_HOPE_DELIVERY: 'PURCHASE_DECISION_VALIDATION_FAILED_HOPE_DELIVERY',
    ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
    DEFAULT_ERROR_MESSAGE: 'DEFAULT_ERROR_MESSAGE',
    ORDER_PAY_MEMBER_NO_NOT_MATCHED: 'ORDER_PAY_MEMBER_NO_NOT_MATCHED',
    ALL_PRODUCT_ORDERS_PURCHASE_DECIDED: 'ALL_PRODUCT_ORDERS_PURCHASE_DECIDED',
    INVALID_ORDER_NO: 'INVALID_ORDER_NO',
    ORDER_NO_PRODUCT_ORDER_NO_NOT_MATCHED: 'ORDER_NO_PRODUCT_ORDER_NO_NOT_MATCHED',
    PRODUCT_ORDER_NOT_FOUND: 'PRODUCT_ORDER_NOT_FOUND',
    /** 클릭된 상품의 클레임 상태가 구매확정 불가 케이스인 경우 */
    UNABLE_PURCHASE_BY_CLAIMS: 'UNABLE_PURCHASE_BY_CLAIMS',
} as const

export type PurchaseConfirmationErrorCodeType = Constant<typeof PurchaseConfirmationErrorCode>

export const PurchaseConfirmationErrorMessageMap: Record<PurchaseConfirmationErrorCodeType, string> = {
    [PurchaseConfirmationErrorCode.ORDER_NOT_FOUND]: '구매확정 대상 상품이 없습니다.',
    [PurchaseConfirmationErrorCode.INVALID_ORDER_NO]: '구매확정 대상 상품이 없습니다.',
    [PurchaseConfirmationErrorCode.ORDER_NO_PRODUCT_ORDER_NO_NOT_MATCHED]: '구매확정 대상 상품이 없습니다.',
    [PurchaseConfirmationErrorCode.PRODUCT_ORDER_NOT_FOUND]: '구매확정 대상 상품이 없습니다.',
    [PurchaseConfirmationErrorCode.ALL_PRODUCT_ORDERS_PURCHASE_DECIDED]: '구매확정이 이미 완료되었습니다.',
    [PurchaseConfirmationErrorCode.PURCHASE_DECISION_VALIDATION_FAILED_HOPE_DELIVERY]:
        '희망배송일 상품은 희망배송일 이후부터 구매확정이 가능합니다.',
    [PurchaseConfirmationErrorCode.PURCHASE_DECISION_VALIDATION_FAILED]:
        '구매확정이 불가한 상품이 있습니다. 자세한 내용은 네이버페이 고객센터로 문의해주세요.',
    [PurchaseConfirmationErrorCode.ORDER_PAY_MEMBER_NO_NOT_MATCHED]: '유효하지 않은 회원입니다.',
    [PurchaseConfirmationErrorCode.DEFAULT_ERROR_MESSAGE]: '일시적인 오류입니다. 잠시 후 재시도 해주세요.',
    [PurchaseConfirmationErrorCode.UNABLE_PURCHASE_BY_CLAIMS]: '구매확정 대상 상품이 없습니다.',
}

/** alert후 팅겨내야 하는 클레임 상태 */
export const ClaimStatusThrowCase = [
    ClaimStatus.RETURN_REQUEST, // 반품요청
    ClaimStatus.EXCHANGE_REQUEST, // 교환요청
    ClaimStatus.COLLECTING, // 반품중, 교환중
    ClaimStatus.COLLECT_DONE, // 반품수거완료, 교환수거완료
]

/** alert를 표시 해주어야 하는 클레임 상태 */
export const ClaimStatusAlertCase = [
    ClaimStatus.EXCHANGE_REDELIVERING, // 교환 재배송중
]
